<template>
  <v-app>
    <!-- Navigation Drawer -->
    <v-navigation-drawer
      app
      clipped
      width="280"
      class="white"
      v-model="drawerOpen"
      :temporary="display.mobile.value"
    >
      <!-- Logo & Nav Items -->
      <v-toolbar flat dense class="justify-center">
        <v-img
          :src="logo"
          contain
          height="100"
          @click="gotoHome"
          style="cursor: pointer"
        />
      </v-toolbar>
      <v-list dense nav>
        <!-- Overview -->
        <v-list-item
          class="py-3"
          :to="{ name: 'Overview' }"
          link
          :disabled="!profileDone"
        >
          <div style="display: flex; justify-content-between">
            <v-list-item-icon
              :class="
                profileDone ? 'primary--text' : 'grey--text text--darken-1'
              "
            >
              <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="ml-8 mt-2">
              <v-list-item-title
                :class="
                  profileDone
                    ? 'black--text font-weight-regular'
                    : 'grey--text text--darken-1 font-weight-regular'
                "
                style="font-size: 15px; font-weight: 800"
                >Overview</v-list-item-title
              >
            </v-list-item-content>
          </div>
        </v-list-item>

        <!-- Jobs Dashboard -->
        <v-list-item
          class="py-3"
          :to="{ name: 'JobsDashboard' }"
          link
          :disabled="!profileDone"
        >
          <div style="display: flex; justify-content-between">
            <v-list-item-icon
              :class="
                profileDone ? 'primary--text' : 'grey--text text--darken-1'
              "
            >
              <v-icon>mdi-briefcase-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="ml-8 mt-2">
              <v-list-item-title
                :class="
                  profileDone
                    ? 'black--text font-weight-regular'
                    : 'grey--text text--darken-1 font-weight-regular'
                "
               class="profile-done"
                >Jobs Dashboard</v-list-item-title
              >
            </v-list-item-content>
          </div>
        </v-list-item>

        <!-- Candidate Search -->
        <v-list-item
          class="py-3"
          :to="{ name: 'CandidateSearch' }"
          link
          :disabled="!profileDone"
        >
          <div  style="display: flex; justify-content-between">
            <v-list-item-icon
              :class="
                profileDone ? 'primary--text' : 'grey--text text--darken-1'
              "
            >
              <v-icon>mdi-account-search-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="ml-8 mt-2">
              <v-list-item-title
                :class="
                  profileDone
                    ? 'black--text font-weight-regular'
                    : 'grey--text text--darken-1 font-weight-regular'
                "
                style="font-size: 15px; font-weight: 800"
                >Candidate Search</v-list-item-title
              >
            </v-list-item-content>
          </div>
        </v-list-item>
      </v-list>

      <v-divider class="my-4" />

      <!-- Post Job Button -->
      <v-btn
        style="text-transform: none !important; width: 40px; border-radius: 5px"
        block
        class="mb-4 font-weight-medium"
        elevation="1"
        dark
        :disabled="!profileDone"
        :color="profileDone ? '#B8860B' : ''"
        @click="postJob"
      >
        + POST A JOB
      </v-btn>

      <!-- Latest Update -->
      <v-card outlined class="pa-4 mb-4">
        <div class="d-flex align-center mb-3">
          <v-img :src="updateIcon" max-width="36" class="mr-2" />
          <div class="subtitle-1 font-weight-medium">Latest Update!</div>
        </div>
        <div v-for="(item, i) in updates" :key="i" class="update-item mb-4">
          <div class="update-date">{{ item.date }}</div>
          <div class="update-text mb-1">{{ item.text }}</div>
          <v-btn text small class="pa-0">Show More</v-btn>
        </div>
      </v-card>

      <!-- Feedback -->
      <v-card outlined class="pa-4 text-center">
        <v-img :src="feedbackIcon" max-width="300" class="mx-auto mb-2" />
        <div class="body-2 mb-3">Share your thoughts on the new interface.</div>
        <v-btn outlined small>
          <v-icon left>mdi-message-alert-outline</v-icon> SHARE FEEDBACK
        </v-btn>
      </v-card>
    </v-navigation-drawer>

    <!-- App Bar -->
    <v-app-bar app color="white" elevation="1">
      <v-btn
        v-if="display.mobile.value"
        icon
        class="mr-1"
        aria-label="Go back"
        @click="goBack"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-btn
        v-if="display.mobile.value"
        icon
        class="mr-1"
        aria-label="Open menu"
        @click="drawerOpen = true"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-spacer />

      <v-menu>
        <template #activator="{ props }">
          <v-btn icon v-bind="props">
            <v-avatar color="#B8860B">
              <span class="white--text">
                {{
                  user.fullName
                    ?.split(" ")
                    .map((n) => n[0])
                    .join("")
                    .slice(0, 1)
                }}
              </span>
            </v-avatar>
          </v-btn>
        </template>
        <v-list>
          <v-list-item link @click="gotoProfile">
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <v-list-item link>
            <v-list-item-title>How to use?</v-list-item-title>
          </v-list-item>
          <v-list-item link>
            <v-list-item-title>Legal Hub</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="handleLogout">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- Main Content -->
    <v-main>
      <v-container fluid class="py-10 dash-container">
        <!-- Routes -->
        <CandidateSearch v-if="$route.name === 'CandidateSearch'" />
        <JobsDashboard v-else-if="$route.name === 'JobsDashboard'" />
        <OverviewPage v-else-if="$route.name === 'Overview'" />
        <PlaceAdForJob v-else-if="$route.name === 'PlaceAnAd'" />
        <PickSubCategoryForJob
          v-else-if="$route.name === 'PickSubCategoryForJob'"
        />
        <SelectYourCityForJobPost
          v-else-if="$route.name === 'SelectYourCityForJobAd'"
        />
        <GeneralGroupsListComponentForJob
          v-else-if="$route.name === 'GeneralGroupsListComponentForJob'"
        />
        <GeneralSectionsListComponentForJob
          v-else-if="$route.name === 'GeneralSectionsListComponentForJob'"
        />
        <GeneralListingSignUpComponentForJob
          v-else-if="$route.name === 'GeneralListingSignUpForJob'"
        />

        <CarSignUpFormForJob
          v-else-if="$route.name === 'CarSignUpFormForJob'"
        />

        <SuccessPageForJob v-else-if="$route.name === 'SuccessPageForJob'" />

        <!-- Profile Forms (create via query param) -->
        <PersonalProfileForm
          v-else-if="showForm && userType === 'individual'"
          :cities="cities"
          @save="saveProfile"
        />
        <CompanyProfileForm
          v-else-if="showForm && userType === 'company'"
          :cities="cities"
          :companyTypes="companyTypes"
          :industries="industries"
          :companySizes="companySizes"
          @save="saveCompanyProfile"
        />

        <!-- Show profile form (edit mode) -->
        <div v-else-if="profileDone">
          <PersonalProfileForm
            v-if="personalDone"
            :cities="cities"
            :initialData="store.getters['personalProfile/profile']"
            @save="saveProfile"
          />
          <CompanyProfileForm
            v-else
            :cities="cities"
            :companyTypes="companyTypes"
            :industries="industries"
            :companySizes="companySizes"
            :initialData="store.getters['companyProfile/companyProfile']"
            @save="saveCompanyProfile"
          />
        </div>

        <!-- Show profile selector cards if no profile is done -->
        <div v-else>
          <div class="text-center mb-8">
            <h2 class="text-h4 font-weight-medium">Who are you hiring for?</h2>
            <p>Your dashboard will be customized based on your selection</p>
          </div>
          <v-row justify="center" align="stretch" dense>
            <v-col cols="12" md="5">
              <v-card elevation="2" class="pa-6 text-center selection-card">
                <v-img
                  :src="personalIcon"
                  max-width="120"
                  class="mx-auto mb-4"
                />
                <div class="body-1 mb-4">
                  Source candidates for individual services.<br />
                  Eg: Drivers, Tutors, House help etc.
                </div>
                <v-btn color="#B8860B" dark @click="goPersonal">
                  PERSONAL <v-icon right>mdi-chevron-right</v-icon>
                </v-btn>
              </v-card>
            </v-col>
            <v-col cols="12" md="5">
              <v-card elevation="2" class="pa-6 text-center selection-card">
                <v-img
                  :src="companyIcon"
                  max-width="120"
                  class="mx-auto mb-4"
                />
                <div class="body-1 mb-4">
                  Source candidates for corporate jobs.<br />
                  Eg: Engineers, Accountants, Front desk etc.
                </div>
                <v-btn color="#B8860B" dark @click="goCompany">
                  COMPANY <v-icon right>mdi-chevron-right</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
          <div class="text-center mt-10 italic-note">
            *If you want to update this later please contact our customer
            support at 000 suuq.
          </div>
        </div>
      </v-container>
    </v-main>
  </v-app>

  <FooterMobile v-if="display.mobile.value" />
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";
import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";


import logo from "@/assets/suuq.logo.svg";
import updateIcon from "@/assets/Rockets.svg";
import feedbackIcon from "@/assets/feedback.svg";
import personalIcon from "@/assets/individual.svg";
import companyIcon from "@/assets/company.svg";

import FooterMobile from "../footer/FooterMobile.vue";

import PersonalProfileForm from "@/components/Dashboard/PersonalProfileForm.vue";
import CompanyProfileForm from "@/components/Dashboard/CompanyProfileForm.vue";

import CitiesService from "@/services/cities.services";
import CompanyTypeService from "@/services/companyType.service";
import IndustryService from "@/services/industry.service";
import CompanySizeService from "@/services/companySize.service";
import CandidateSearch from "@/components/Dashboard/CandidateSearch.vue";
import JobsDashboard from "@/components/Dashboard/JobsDashboard.vue";
import OverviewPage from "@/components/Dashboard/OverviewPage.vue";
import PlaceAdForJob from "@/views/PlaceAdForJob.vue";
import SelectYourCityForJobPost from "@/views/SelectYourCityForJobPost.vue";
import GeneralGroupsListComponentForJob from "../GeneralGroupsListComponentForJob.vue";
import GeneralSectionsListComponentForJob from "@/components/GeneralSectionsListComponentForJob.vue";
import GeneralListingSignUpComponentForJob from "@/components/GeneralListingSignUpComponentForJob.vue";
import SuccessPageForJob from "@/views/SuccessPageForJob.vue";
import PickSubCategoryForJob from "@/components/PickSubCategoryForJob.vue";
import CarSignUpFormForJob from "@/components/CarSignUpFormForJob.vue";
import { useDisplay } from "vuetify";

const router = useRouter();
const route = useRoute();
const store = useStore();
const display = useDisplay();

const loadingData = ref(false);

const user = computed(() => store.state.auth.user || {});

const userType = computed(() => route.query.user_type || "");
const showForm = computed(
  () =>
    route.path === "/ats/profile" &&
    ["individual", "company"].includes(userType.value)
);

function goPersonal() {
  router.push({ path: "/ats/profile", query: { user_type: "individual" } });
}
function goCompany() {
  router.push({ path: "/ats/profile", query: { user_type: "company" } });
}

const personalDone = computed(() => !!store.getters["personalProfile/profile"]);
const companyDone = computed(
  () => !!store.getters["companyProfile/companyProfile"] // or 'company' if you rename it
);
const profileDone = computed(() => personalDone.value || companyDone.value);

// dropdown data
const cities = ref([]);
const companyTypes = ref([]);
const industries = ref([]);
const companySizes = ref([]);




// OPEN by default on desktop, CLOSED by default on mobile
const drawerOpen = ref(!display.mobile.value);

// Keep it open when switching to desktop, and closed on mobile
watch(() => display.mobile.value, (isMobile) => {
  drawerOpen.value = !isMobile;
});


router.afterEach(() => {
  if (display.mobile.value) drawerOpen.value = false;
});


// static updates
const updates = ref([
  {
    date: "January 8, 2025",
    text: "Contact potential candidates via WhatsApp for a seamless experience. Credits will ...",
  },
  {
    date: "January 8, 2025",
    text: "You can now delete draft job ads, giving you more control over ad management. Try ...",
  },
  {
    date: "October 2, 2024",
    text: "Candidate search now auto-applies filters from your latest job post, making it eas...",
  },
]);

onMounted(async () => {
  loadingData.value = true;
  try {
    // fetch all dropdowns in parallel
    const [cRes, tRes, iRes, sRes] = await Promise.all([
      CitiesService.index(),
      CompanyTypeService.index(),
      IndustryService.index(),
      CompanySizeService.index(),
    ]);

    cities.value = cRes.data.data;
    companyTypes.value = tRes.data.data;
    industries.value = iRes.data.data;
    companySizes.value = sRes.data.data;

    await store.dispatch("personalProfile/fetchProfile");
    await store.dispatch("companyProfile/fetchCompany");
  } catch (err) {
    store.dispatch("alert/error", "Failed to load dashboard data");
  } finally {
    loadingData.value = false;
  }
});

async function saveProfile(formData) {
  try {
    await store.dispatch("personalProfile/saveProfile", formData);
    store.dispatch("alert/success", "Personal profile saved successfully");
  } catch (err) {
    store.dispatch(
      "alert/error",
      err.response?.data?.message || "Failed to save personal profile"
    );
  }
}

async function saveCompanyProfile(formData) {
  try {
    await store.dispatch("companyProfile/saveCompany", formData);
    store.dispatch("alert/success", "Company profile saved successfully");
  } catch (err) {
    store.dispatch(
      "alert/error",
      err.response?.data?.message || "Failed to save company profile"
    );
  }
}

function postJob() {
  router.push({ name: "SelectYourCityForJobAd" });
}

function gotoProfile() {
  if (personalDone.value) {
    // user has already filled personal profile
    router.push({ name: "GuestProfile", query: { user_type: "individual" } });
  } else if (companyDone.value) {
    // user has already filled company profile
    router.push({ name: "GuestProfile", query: { user_type: "company" } });
  } else {
    // neither done yet: send them to the initial selector
    router.push({ name: "GuestDashboard" });
  }
}

function gotoHome() {
  router.push("/");
}

const getInitials = (name) =>
  name
    ?.split(" ")
    .map((n) => n[0])
    .join("")
    .substring(0, 2) || "??";

async function handleLogout() {
  await store.dispatch("auth/logout");
  router.push({ name: "Home" });
}

function goBack() {
  // If there's history, go back; otherwise fall back to Home
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push({ name: "Home" });
  }
}
</script>
<style scoped>
.selection-card {
  transition: transform 0.2s;
}
.selection-card:hover {
  transform: translateY(-4px);
}
.italic-note {
  font-style: italic;
  color: #555;
}
.update-item {
  border-bottom: 1px solid #eee;
  padding-bottom: 1rem;
}
.update-date {
  font-size: 0.75rem;
  color: #888;
  margin-bottom: 0.25rem;
}
.update-text {
  font-size: 0.875rem;
  color: #333;
}

/* ===== Mobile-only adjustments ===== */
@media (max-width: 768px) {
  /* Make drawer feel native on phones */
  :deep(.v-navigation-drawer) {
    max-width: 86vw; /* a bit narrower than full screen */
  }

  /* App bar buttons spacing */
  :deep(.v-app-bar .v-btn) {
    touch-action: manipulation;
  }

  /* Main container padding on mobile */
  .dash-container {
    padding-top: 12px !important;
    padding-left: 12px !important;
    padding-right: 12px !important;
    padding-bottom: 84px !important; /* space for FooterMobile */
  }

  /* Selection cards tighter on mobile */
  .selection-card {
    padding: 16px !important;
  }

  /* Update & feedback cards: compact text on mobile */
  .update-text {
    font-size: 0.85rem;
  }
  .update-date {
    font-size: 0.75rem;
  }

  /* Make “POST A JOB” button span full width if shown in drawer on mobile */
  :deep(.v-navigation-drawer .v-btn[block]) {
    width: 100% !important;
  }
}

.profile-done{
  font-size: 15px !important; 
  font-weight: 800 !important;
}
</style>
